import type {FlexProps} from "@/styles/flex.types";

import {css} from "styled-components";

const vertical = {
    top: "flex-start",
    middle: "center",
    bottom: "flex-end"
};

const horizontal = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    between: "space-between"
};

const direction = {
    vertial: 'column',
    horizontal: 'row'
};

export const flex = (
    {
        flex,
        flexAlignVertical,
        flexAlignHorizontal,
        flexDirection,
        flexAlignSelf,
        flexChildAuto
    }: FlexProps) => {
    return css`
      ${flex && css`display: flex;`}
      ${flexAlignVertical && css`align-items: ${vertical[flexAlignVertical]};`}
      ${flexAlignHorizontal && css`justify-content: ${horizontal[flexAlignHorizontal]};`}
      ${flexDirection && css`flex-direction: ${direction[flexDirection]};`}
      ${flexAlignSelf && css`align-self: ${flexAlignSelf}`}
      ${flexChildAuto && css`& > * {
        width: auto;
        flex: 1;
      }`}
    `;
};
